var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSol(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.08
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_298_7529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.31601 20.2118C9.43921 20.0886 9.6086 20.0167 9.78826 20.0167H26.0809C26.3786 20.0167 26.5275 20.376 26.317 20.5865L23.0985 23.805C22.9753 23.9282 22.8059 24 22.6263 24H6.33365C6.03593 24 5.88707 23.6407 6.09753 23.4303L9.31601 20.2118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31601 8.19506C9.44434 8.07186 9.61374 8 9.78826 8H26.0809C26.3786 8 26.5275 8.35932 26.317 8.56978L23.0985 11.7883C22.9753 11.9115 22.8059 11.9833 22.6263 11.9833H6.33365C6.03593 11.9833 5.88707 11.624 6.09753 11.4135L9.31601 8.19506Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0985 14.1649C22.9753 14.0417 22.8059 13.9699 22.6263 13.9699H6.33365C6.03593 13.9699 5.88707 14.3292 6.09753 14.5397L9.31601 17.7581C9.43921 17.8813 9.6086 17.9532 9.78826 17.9532H26.0809C26.3786 17.9532 26.5275 17.5939 26.317 17.3834L23.0985 14.1649Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_298_7529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.5,
    height: 16,
    fill: "white",
    transform: "translate(6 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSol);
export default __webpack_public_path__ + "static/media/SOL.70239d9c0a707b75c75f72accb204335.svg";
export { ForwardRef as ReactComponent };